module.exports = __webpack_public_path__ + "img/cancel-gray.73adace4.svg";